import React from 'react'
import ReactDOM from 'react-dom'
import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'

// app
import Application from './Application'
import GlobalPrintStyles from './Application.styles'

// libraries
import { Router } from 'react-router-dom'
import { createBrowserHistory } from 'history'
import { ThemeProvider } from 'styled-components'
import theme from './components/_base/theme'
import { Provider } from 'react-redux'
import configureStore from './settings/app/storeConfig'
import { PersistGate } from 'redux-persist/integration/react'

// hocs && hooks
import {
  MetaInformation,
  TextContextProvider,
  EnvironmentSetter,
  RedirectProvider,
  CostEstimateProvider,
  ProviderComposer,
} from 'hocs'
import { MobileSwitchProvider } from 'hooks/MobileSwitch'

// dev tools && sentry
import './sentry/load'
import loadDevTools from './dev-tools/load'
import featureToggles from 'feature-toggles'

// load navigator app only when #appReactNavigatoren exists
if (document.getElementById('appReactNavigatoren')) {
  loadDevTools(() => {
    const { store, persistor } = configureStore()
    const basePathFromLocalStorage = localStorage.getItem('basePath')
    const history = createBrowserHistory({
      basename: basePathFromLocalStorage || '/',
    })

    const providers = [
      featureToggles.persistStore
        ? [PersistGate, { persistor }]
        : [React.Fragment],
      [Provider, { store }],
      [ThemeProvider, { theme }],
      [Router, { history }],
      [EnvironmentSetter],
      [RedirectProvider],
      [MobileSwitchProvider, { breakpoint: 'sm' }],
      [TextContextProvider],
      [MetaInformation],
      [CostEstimateProvider],
    ]

    ReactDOM.render(
      <ProviderComposer providers={ providers }>
        <GlobalPrintStyles />
        <Application />
      </ProviderComposer>,
      document.getElementById('appReactNavigatoren')
    )
  })
  // remove loader in typo
  const loader = document.getElementById('appReactNavigatorenLoader')
  if (loader) {
    loader.parentNode.removeChild(loader)
  }
  // remove error panel if app loaded
  const errorPanel = document.getElementById('errorPanel')
  if (errorPanel) {
    errorPanel.parentNode.removeChild(errorPanel)
  }
}

// if (__dev__ && __show_axe__) {
//     const axe = require('react-axe')
//     const axeCore = require('axe-core')
//     // console.log(axeCore)
//     const axeConfig = {
//         rules: axeCore.getRules(['wcag2aa', 'wcag2a']).map(rule => ({ ...rule, id: rule.ruleId, enabled: true })),
//         disableOtherRules: true,
//     }
//     axe(React, ReactDOM, 1000, axeConfig)
// }

// serviceWorker.register()
